// extracted by mini-css-extract-plugin
export default {"title":"panel-header_title__WDZen","description":"panel-header_description__A+3Wb"};